export default __webpack_public_path__ + "static/media/893.ad4d130f.gif";